import { css } from '@emotion/react';
import { Avatar, Grid, Typography } from '@material-ui/core';
import {
	backToLoginCss,
	dialogTitleCss as BaseDialogTitleCss,
	forgotPasswordCss,
	forgotPasswordTextCss,
	fullWidthCss,
} from 'components/shared/Dialog/styles';
import { i18n } from 'lib/i18n';
import successIcon from 'public/media/login/success-reset.svg';
import { Dispatch, FC, SetStateAction } from 'react';
import { useColors } from 'hooks/useColors';
import { IColors } from 'types/colors'; // import { colors } from 'styles/theme';

const dialogTitleCss = (colors: IColors) => css`
	${BaseDialogTitleCss(colors)};
	&.MuiTypography-h5 {
		font-weight: 500;
		font-size: 2.2rem;
	}
`;

const successIconCss = css`
	&.MuiAvatar-root {
		width: 120px;
		height: 120px;
		margin: 0 auto;
	}
`;

interface SuccessDialogProps {
	fromLoginPage?: boolean;
	successPageEmail: string;
	setIsForgotPass: (values: boolean) => void;
	setSuccessPage: Dispatch<SetStateAction<boolean>>;
}

const SuccessDialog: FC<SuccessDialogProps> = props => {
	const { successPageEmail, fromLoginPage, setSuccessPage, setIsForgotPass } = props;

	const { colors } = useColors();

	return (
		<div css={forgotPasswordCss}>
			{!fromLoginPage && (
				<Grid
					container
					direction="column"
					justify="flex-end"
					alignItems="flex-start"
					css={backToLoginCss(colors)}
					onClick={() => {
						setIsForgotPass(false);
						setSuccessPage(false);
					}}
				>
					<p>{i18n.loginDialog.backToLogin}</p>
				</Grid>
			)}
			<div>
				<div>
					<Avatar src={successIcon} variant="square" css={successIconCss} />
				</div>
				<div css={fullWidthCss}>
					<Typography component="h1" variant="h5" css={dialogTitleCss(colors)} id="login-dialog-title">
						{i18n.loginDialog.successTitle}
					</Typography>
					<Typography component="h1" variant="h5" css={forgotPasswordTextCss(colors)} id="login-dialog-title">
						{i18n.loginDialog.successTextWithEmail} <b>{successPageEmail}</b>
						<br />
						{i18n.loginDialog.successText}
					</Typography>
				</div>
			</div>
		</div>
	);
};

export default SuccessDialog;
